<template>
    <support-shortcut-modal  v-model="budgetBidModal"
                  size="small"
                  :title="budget_bid_data.type === DEFAULT_BUDGET ? $bp_t('修改预算', 'common.budget_revision') : $bp_t('预算定时任务', 'bp.promotion_budget_timing_task') "
                  class="budget-time-task-modal"
                  @hide="onModalHide"
                  @ok="budget_bid_data.type === DELETE_TASK ? onDeleteTask(true) : onClickConfirm(true)"
                  >
      <template slot="body">
        <div class="budget-input-wrapper">
          <byted-form
            ref="condition-form"
            layoutType="horizontal"
            labelWidth="70px"
            labelAlign="left">
            <!-- 预算 -->
            <template v-if="budget_bid_data.type === DEFAULT_BUDGET">
              <byted-form-item :label="$bp_t('预算', 'common.budget')" prop='budget' ref="budget">
                <byted-input
                  ref="budgetInput"
                  v-model="budget_bid_data.value"
                  @change="onBudgetChange"
                  :placeholder="$bp_t('请输入预算值', 'bp.promotion_please_enter_budget_value')"
                  style="width:200px;"
                ></byted-input>
                <span class="error_message">{{errorMessage}}</span>
              </byted-form-item>
            </template>
            <!-- 定时任务 -->
            <template v-if="budget_bid_data.type === DEFAULT_TIME_TASK">
              <byted-form-item :label="$bp_t('预约值', 'bp.promotion_appointment_value')" prop='timedTask' ref="timedTask">
                <byted-input
                  ref="budgetInput"
                  v-model="budget_bid_data.value"
                  @change="onTimedTaskChange"
                  :placeholder="$bp_t('请输入预约值', 'bp.promotion_please_enter_appointment_value')"
                  style="width:200px;"
                ></byted-input>
                <span class="error_message">{{errorMessage}}</span>
              </byted-form-item>
              <span class="time_task_tip">{{ $bp_t('设置的定时任务将于次日凌晨00:00时生效', 'bp.promotion_the_set_scheduled_task') }}</span>
            </template>
            <!-- 删除预算 -->
            <template v-if="budget_bid_data.type === DELETE_TASK">
              {{ $bp_t('确定要删除该计划定时任务？', 'bp.promotion_are_you_sure_you_want_to_delete_this_scheduled_task') }}
              <div class="error_message">{{errorMessage}}</div>
            </template>

          </byted-form>
        </div>
      </template>
      <template slot="footer">
        <byted-button type="default"
                @click="onModalHide">{{ $bp_t('取消', 'common.cancel') }}</byted-button>
        <byted-button type="primary"
                @click="budget_bid_data.type === DELETE_TASK ? onDeleteTask() : onClickConfirm()">{{ $bp_t('确定', 'common.determine') }}</byted-button>
      </template>
    </support-shortcut-modal>
</template>
<script>
  import Tool from 'Src/util/tool.js'
  import { budgetAndTimedTask } from 'Src/const/state/statistics-fields-promotion.js'
  import commonTea from 'Src/pagelets/promotion/support/common-tea.js'

  export default {
    name: 'budget-bid-modal',
    mixins: [commonTea],
    props: {
      value: {
        type: Boolean,
        default: false
      },
      budget_bid_data: {
        type: Object,
        default: {
          type: 1,
          value: '0',
          errorMessage: ''
        }
      }
    },
    data () {
      return {
        DEFAULT_BUDGET: budgetAndTimedTask.budget,
        DEFAULT_TIME_TASK: budgetAndTimedTask.timedTask,
        DELETE_TASK: budgetAndTimedTask.deleteTask,
        errorMessage: this.budget_bid_data.errorMessage,
        budgetBidModal: this.value
      }
    },
    watch: {
      budget_bid_data: {
  　　　　handler(newValue, oldValue) {
            this.errorMessage = newValue.errorMessage
            this.$forceUpdate()
  　　　　},
  　　　　deep: true
　　  },
      value (val) {
        this.budgetBidModal = val
        if (this.budgetBidModal) {
          setTimeout(() => {
            if (this.$refs.budgetInput && this.$refs.budgetInput.focus) {
              this.$refs.budgetInput.focus()
            }
          }, 350)
        }
      }
    },
    mounted () {},
    methods: {
      getValidResult (val) {
        let validResult = Tool.validNumberString(val)
        if (validResult !== '') {
          this.budget_bid_data.errorMessage = validResult
          return
        } else {
          this.budget_bid_data.errorMessage = ''
        }
      },
      onBudgetChange (val) {
        this.getValidResult(val)
      },
      onTimedTaskChange (val) {
        this.getValidResult(val)
      },
      onClickConfirm(isShortcut) {
          this.$emit('submit', {value: this.budget_bid_data.value})

          this.okModal('ad', 'bugetEdit', isShortcut === true ? 'shortcut' : 'btn')
      },
      onModalHide (isShortcut) {
          this.$emit('cancel', false)

          this.cancelModal('ad', 'bugetEdit', isShortcut === true ? 'shortcut' : 'btn')
      },
      onDeleteTask (isShortcut) {
        this.$emit('delete', {value: this.budget_bid_data.value})

        this.okModal('ad', 'bugetEdit', isShortcut === true ? 'shortcut' : 'btn')
      }
  }
}
</script>
<style lang="scss">
  @import 'Src/basic/theme.scss';

  $filter-right-part-width: 200px;
  $filter-right-part-margin: 24px;

  $basic-padding: 24px;
  $filter-height: 30px;
  $basic-border-radius: 4px;

  $small-font-size: 12px;
  $icon-size: 14px;
  .budget-time-task-modal {
    .error_message {
      font-size: 12px;
      color: red;
    }
    .time_task_tip {
      font-size: 12px;
      color: #999;
    }
    .byted-form-item {
      margin-bottom: 12px;
    }
  }
  html {
    &:lang(en) {
      .budget-time-task-modal {
        .byted-form-item {
          > div {
            margin-left: 100px!important;
          }
        }
      }
    }
  }
</style>
